<div class="section">
  <h4 class="title">Worklist Bucket Management</h4>
  <div class="row">
      <div class="col-md-4">
          <div class="search-hero">
              <input class="form-control" type="text" name="search2" style="font-family: FontAwesome;"
                  [(ngModel)]="searchQR" autocomplete="off" placeholder="&#xf002; Search...">
          </div>
      </div>
      <!-- <div class="col-md-8 text-right">
          <button type="button" class="btn btn-primary mr-0" (click)="client_form()">Add</button>
      </div> -->
  </div>
  <div class="doc-table">
      <div class="card-box"> <p-table [value]="rows" styleClass="ui-table-customers" #tt [paginator]="true" [rows]="5"
          [rowHover]="true" [rowsPerPageOptions]="[5,10,25,50]" [showCurrentPageReport]="true"
          currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
          [globalFilterFields]="['type']">
          <ng-template pTemplate="header">
              <tr class="thhead">
                  <th class="th-1">
                      S.No
                  </th>
                  <th>
                     Bucket ID
                  </th>
                  <th>
                  Bank
                 </th>
                 <th>
                   Portfolio
                 </th>

                 <th>
                    Date of Assign
                  </th>

                  <th style="width: 110px;text-align:center">
                      Action
                  </th>
              </tr>
          </ng-template>
          <ng-template pTemplate="body" let-item let-i="rowIndex">
              <tr class="tdrow">
                  <td>{{i+1}}</td>
                  <td>{{item.bucket_id}}</td>

                  <td>
                    <select [(ngModel)]="item.bank_id" class="form-control" disabled>
                   <option *ngFor="let item of origianl_bank_list" [value]="item._id">{{item.bank_name}}</option>
                   </select>
                  </td>
                 <td>
                   <select [(ngModel)]="item.porfolio_id" class="form-control" disabled>
                       <option *ngFor="let item of original_portfolio_list" [value]="item._id">{{item.portfolio_type}}</option>
                   </select>
                 </td>
                 <!-- <td>{{item.bank_name.bank_name}}</td>
                 
                 <td>{{item.product_id.product_type}}</td>
                 <td>{{item.portfolio_id.portfolio_type}}</td>
                 <td>{{item.record_count}}</td>
                 <td>{{item.allocated_record}}</td>
                 <td>{{item.not_allocated_record}}</td>
                 <td>{{item.createdAt | date}}</td> -->
                 <td>{{item.date_of_assign | date}}</td>
               
                  <td class="act">
                      <i style="color: #4CAF50;" class="fa fa-user" aria-hidden="true" (click)="move_to_select(item)"
                          pTooltip="View Record"></i>
                  </td>
              </tr>
          </ng-template>
       </p-table>  </div>
  </div>
</div>
